<div class="fdk-initials fdk-initials--{{ size }}">
  {{ displayedInitials }}
</div>
